import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Seo, { breadcrumbLd } from "@/components/site/Seo";

const CONTENT = {
  "refund-policy": {
    title: "Refund & Cancellation Policy",
    body: [
      ["Tours & cohorts", "Deposits secure your seat and are refundable up to a stated cut-off date before departure, less any non-recoverable third-party costs (visa invitations, hotel blocks). Balances are due by the date shown at checkout. Cancellations after the cut-off may be non-refundable; substitutions of travellers are usually permitted."],
      ["Digital guides", "Paid digital guides are delivered instantly via a secure download link. Because the content is consumed immediately, digital guide sales are generally non-refundable except where the file is defective or was not delivered."],
      ["How to request", "Email the team with your booking reference. We confirm eligibility against this policy and process approved refunds to the original payment method."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      ["What we collect", "Contact details you submit (name, WhatsApp, email, company, country), your enquiry content and any files you upload, plus basic analytics events to improve the site."],
      ["How we use it", "To respond to your enquiry, deliver guides and tours, and improve our services. We do not sell your data."],
      ["Payments", "Payments are processed by Razorpay (INR) or Stripe (USD). We do not store full card details on our servers."],
      ["Contact", "To access or delete your data, contact the team via the Contact page."],
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      ["Scope", "The Sourcing Atlas provides sourcing, verification, inspection, shipping coordination and trade-tour services. Indicative guidance on the site does not constitute a binding quote."],
      ["Commissions & pricing", "Sourcing fees are a transparent commission on order value, quoted per brief and disclosed up front. Tour prices are shown per cohort in INR and USD."],
      ["Buyer responsibilities", "Buyers are responsible for their own regulatory compliance, including certification and import licensing (notably for medical equipment)."],
      ["Liability", "We apply our verification standard diligently but do not guarantee outcomes of third-party suppliers beyond the scope agreed per engagement."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <SiteLayout>
      <Seo
        title={`${c.title} | The Sourcing Atlas`}
        description={`${c.title} for The Sourcing Atlas — sourcing services from China, India, Vietnam and Thailand.`}
        path={`/${type}`}
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: c.title, path: `/${type}` }])]}
      />
      <div className="crumb"><Link to="/">Home</Link> › {c.title}</div>
      <div className="simplepage">
        <h1>{c.title}</h1>
        {c.body.map(([h, p], i) => (
          <div key={i}><h2>{h}</h2><p>{p}</p></div>
        ))}
      </div>
    </SiteLayout>
  );
}
